// Coordination « une seule capture en lecture à la fois » : chaque ligne a son
// propre <audio>, mais démarrer une lecture met en pause celle qui jouait. État
// volontairement module-level (singleton) pour coordonner toutes les lignes sans
// remonter d'état React. Le composant écoute l'événement `pause` de son <audio>
// (déclenché par cette mise en pause) pour remettre son bouton sur ▶.
let current: HTMLAudioElement | null = null;

// Démarre la lecture de `audio` en mettant en pause la lecture exclusive en cours.
// Avale un éventuel rejet de play() (WKWebView peut refuser l'autoplay).
export function playExclusive(audio: HTMLAudioElement): void {
  if (current && current !== audio) current.pause();
  current = audio;
  const p = audio.play() as unknown as Promise<void> | undefined;
  if (p && typeof p.catch === "function") p.catch(() => {});
}

// À appeler quand un <audio> se met en pause / se termine (via son event handler).
// Libère la référence courante s'il s'agit de cet élément.
export function notePaused(audio: HTMLAudioElement): void {
  if (current === audio) current = null;
}

// Réservé aux tests.
export function _resetExclusivePlayback(): void {
  current = null;
}
